/* @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import styled from '@emotion/styled';

const AddressAutocompleteSuggestions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1;

  padding: 1rem 0;
  background: white;
  box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.05),
    0px 5.39259px 7.64444px rgba(0, 0, 0, 0.0303704),
    0px 1.14074px 1.95556px rgba(0, 0, 0, 0.0196296);
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;

  &:empty:before {
    display: block;
    content: 'Loading...';
  }
`;

const AddressAutocompleteSuggestion = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px dotted #f2f2f2;
  padding: 0.5rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 400;

  &.address-autocomplete-suggestion--active {
    background-color: rgba(60, 9, 108, 0.1);
  }
`;

type AddressAutocompleteProps = {
  onChange: (object) => void;
  value: any;
  error?: {
    message: string;
  };
};

const AddressAutocomplete = ({ onChange, value }: AddressAutocompleteProps) => {
  const [address, setAddress] = React.useState('');

  const handleSelect = (address) => {
    setAddress(address);
    geocodeByAddress(address).then(onChange);
  };

  useEffect(() => {
    if (value) {
      handleSelect(value);
    }
  }, []);

  return (
    <PlacesAutocomplete
      value={address}
      onChange={setAddress}
      onSelect={handleSelect}
    >
      {({ getInputProps, getSuggestionItemProps, loading, suggestions }) => (
        <div css={{ position: 'relative' }}>
          <input
            style={{
              height: '81px',
              width: '327px',
              padding: '1.0rem',
              background: '#F4F4F4',
              borderRadius: '1.0rem',
              border: 'none',
            }}
            name="address"
            placeholder="Home Address"
            value={value}
            {...getInputProps({})}
          />
          {(loading || suggestions.length > 0) && (
            <AddressAutocompleteSuggestions>
              {suggestions.map((suggestion) => (
                <AddressAutocompleteSuggestion
                  className={
                    suggestion.active &&
                    'address-autocomplete-suggestion--active'
                  }
                  key={suggestion.placeId}
                  {...getSuggestionItemProps(suggestion)}
                >
                  <div>
                    <strong>{suggestion.formattedSuggestion?.mainText}</strong>
                    <br />
                    {suggestion.formattedSuggestion?.secondaryText}
                  </div>
                </AddressAutocompleteSuggestion>
              ))}
            </AddressAutocompleteSuggestions>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default AddressAutocomplete;
